import { nanoid } from 'nanoid';
import { END, eventChannel } from 'redux-saga';

import mainHubInstance from '../../hub/main-hub';

/**
 * Returns unique dialog id
 *
 * @return {string}
 */
export function nextDialogId() {
  return nanoid();
}

/**
 * Subscribe to the dialog response action channel.
 *
 * @param {string} event
 * @param {string} dialogId
 * @return {Channel<{type: *, payload: *}>}
 */
export function subscribeToDialogResponse(event, dialogId) {
  return eventChannel((emitter) => {
    const handler = (response) => {
      if (response.dialogId === dialogId) {
        emitter(response);
        emitter(END);
      }
    };

    mainHubInstance.emmiter.on(event, handler);

    return () => {
      mainHubInstance.emmiter.off(event, handler);
    };
  });
}
